/** Roles that see Merchants in the sidebar. Command search uses the same list. */
export const MERCHANT_NAV_ROLES = [
  'operations',
  'management',
  'support',
  'finance',
  'super_admin',
] as const

/** Roles that see Appointments in the sidebar. */
export const APPOINTMENT_NAV_ROLES = [
  'sales_rep',
  'operations',
  'management',
  'super_admin',
] as const

/**
 * Roles that can open Reports. This is MerchantPolicy::viewAny and
 * nothing wider: portfolio roles see every merchant, and a sales rep
 * sees the merchants they can already list.
 */
export const REPORT_NAV_ROLES = [
  'sales_rep',
  'support',
  'operations',
  'management',
  'finance',
  'super_admin',
] as const
